module.exports = __webpack_public_path__ + "82600b249444accec9e45bf6eae3486a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/rainbow-s.png
// module id = 2324
// module chunks = 0